export default "__VITE_ASSET__D2UJnxmv__"